module.exports = __webpack_public_path__ + "img/graphic_without_characters.897be24e.svg";